/**
 * Kurzer Ton, sobald jemand da ist. Wird im Browser selbst erzeugt, es lädt also keine Datei.
 * Der erste Ton kommt erst nach einem Klick der Person, vorher erlauben Browser keinen Klang.
 */

let context: AudioContext | null = null;

function audioContext(): AudioContext | null {
  if (context) return context;
  const withPrefix = window as typeof window & { webkitAudioContext?: typeof AudioContext };
  const Ctor = window.AudioContext ?? withPrefix.webkitAudioContext;
  if (!Ctor) return null;
  context = new Ctor();
  return context;
}

/** Zwei kurze Töne, der zweite etwas höher. Freundlich, kein Alarm. */
export function playConnectSound(): void {
  const audio = audioContext();
  if (!audio) return;
  if (audio.state === 'suspended') void audio.resume();

  const master = audio.createGain();
  master.gain.value = 0.07;
  master.connect(audio.destination);

  const start = audio.currentTime;
  [659.25, 880].forEach((frequency, index) => {
    const at = start + index * 0.11;
    const oscillator = audio.createOscillator();
    oscillator.type = 'sine';
    oscillator.frequency.value = frequency;
    const gain = audio.createGain();
    gain.gain.setValueAtTime(0.0001, at);
    gain.gain.linearRampToValueAtTime(1, at + 0.02);
    gain.gain.exponentialRampToValueAtTime(0.0001, at + 0.22);
    oscillator.connect(gain).connect(master);
    oscillator.start(at);
    oscillator.stop(at + 0.24);
  });
}
